import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase";
Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    connectedAccount: null,
    isSubscribed: null
  },
  actions: {
    addConnectedAccount({ commit }, payload) {
      return new Promise(async (res, rej) => {
        const db = firebase.firestore();
        db.collection("customers")
          .doc(payload.uid)
          .collection("connected_account")
          .doc("account_info")
          .set(payload)
          .then(() => {
            console.log("Saved connected account info.");
            res();
          })
          .catch(err => {
            rej(err);
            console.log(err);
          });
      });
    },
    getConnectedAccount({ commit }, uid) {
      return new Promise(async (res, rej) => {
        const db = firebase.firestore();
        db.collection("customers")
          .doc(uid)
          .collection("connected_account")
          .doc("account_info")
          .get()
          .then(doc => {
            if (doc.exists) {
              res(doc.data());
            } else {
              res(false);
            }
            // commit("SET_ACCOUNT_INFO", doc.data());
            // console.log(doc.data());
            // console.log("Saved connected account info.");
          })
          .catch(err => {
            rej(err);
            console.log(err);
          });
      });
    },
    checkSubscription({ commit }, { uid }) {
      const db = firebase.firestore();
      db.collection("customers")
        .doc(uid)
        .collection("subscriptions")
        .where("status", "in", ["trialing", "active"])
        .onSnapshot(async snapshot => {
          if (snapshot.empty) {
            console.log("no");
            commit("UPDATE_SUBSCRIPTION_STATUS", false);
          } else {
            console.log("yes");
            commit("UPDATE_SUBSCRIPTION_STATUS", true);
          }
        });
    }
  },
  mutations: {
    UPDATE_SUBSCRIPTION_STATUS(state, status) {
      state.isSubscribed = status;
    }
  },
  getters: {
    subscription(state) {
      return state.isSubscribed;
    }
  }
};
